/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["td[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#7df9e4!important}.column[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{height:30px;text-align:center;margin-bottom:0}.column[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{font-size:20px;text-align:center;margin-left:-3px}.column[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#60dada}.column[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:hover{color:#608bda}"];
export { styles as styles };
